import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonPriceField from '../../../common/fields/PriceField';
import { ArtsAndCraftsDeviationFieldName } from '../../types';
import { MIN_PRICE } from '../../validation';

interface Props {}

const PriceField: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <CommonPriceField
      label={t('artsAndCraftsDeviationPopup.form.price.label')}
      fieldName={ArtsAndCraftsDeviationFieldName.PRICE}
      productType="originals"
      min={MIN_PRICE}
    />
  );
};
PriceField.displayName = 'PriceField';

export default PriceField;
